module.exports = __webpack_public_path__ + "static/scale-model-of-steelstacks-in-allentown-pennsylvania-d17f72992cc2bb02a9bcb9b47b7361b0.png";